<template>
<div class="header_warp">
    <div v-show="!showNav" class="nav_box">
        <img class="img_logo" :src="require('@/common/images/gujingimgs/logo1.png')" alt="">
        <img class="img_menu" @click="showNav = true" :src="require('@/common/images/gujingimgs/icom_menu2.png')" alt="">
    </div>
    <!-- <transition name = "fade"> -->
    <div v-show="showNav" class="nav_open_box" @click="showNav = false">
        <div class="main_warp" @click.stop="showNav = true">
            <div class="nav_box">
                <img class="img_logo" :src="require('@/common/images/gujingimgs/logo1.png')" alt="">
                <img class="img_close" @click.stop="showNav = false" :src="require('@/common/images/gujingimgs/close_nav.png')" alt="">
            </div>
            <div class="nav_content_box">
                <div class="menu_item_warp">
                    <div class="menu_item_box" @click="toPage('GJMIndex')" :class="{'active_menu': $route.name === 'GJMIndex'}">首页</div>
                    <div class="gqgj_box" :class="showSubNav ? 'active' : ''">
                        <div class="parent_box" @click="showSubNav = !showSubNav">
                            <span>股权工具</span>
                            <i></i>
                        </div>
                        <div class="sub_nav_box">
                            <div @click="toPage('MEnterpriseEstimation')" class="sub_item">
                                <p :class="{'p_acitve': $route.name === 'MEnterpriseEstimation'}">企业估值</p>
                            </div>
                            <div @click="toPage('MExcitation')" class="sub_item">
                                <p :class="{'p_acitve': $route.name === 'MExcitation'}">股权激励</p>
                            </div>
                            <!-- <div class="sub_item">
                                <p>股权融资</p>
                            </div>
                            <div class="sub_item">
                                <p>股权结构设计</p>
                            </div>
                            <div class="sub_item">
                                <p>股权问题答疑</p>
                            </div> -->
                        </div>
                        <!-- <transition name = "fade">
                            <div v-show="showSubNav" class="sub_nav_box">
                                11111
                            </div>
                        </transition> -->
                    </div>
                    <div class="menu_item_box" @click="toPage('MEquityLearning')" :class="{'active_menu': $route.name === 'MEquityLearning'}">股权学习</div>
                    <div class="menu_item_box" @click="toPage('MIndividualization')" :class="{'active_menu': $route.name === 'MIndividualization'}">定制服务</div>
                    <div class="menu_item_box" @click="toPage('GJMIndex')" :class="{'active_menu': $route.name === 'GJMIndex'}">关于我们</div>
                </div>
                <div class="btn_div">
                    <div v-if='user.isLogin' class="logged_box">
                        <div @click="toPage('My')">个人中心</div>
                        <div @click="logout">退出登录</div>
                    </div>
                    <div @click="loginBtn" v-if="!user.isLogin" class="not_login">
                        <!-- <router-link :to="{name: 'MLogin'}" class="loginBtn" v-if="!user.isLogin">登录/注册</router-link> -->
                        登录/注册
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- </transition> -->
    <!-- <transition name = "fade">
        <div v-show="showNav" class="nav_open_box">
            <div class="nav_box">
                <img class="img_logo" :src="require('@/common/images/gujingimgs/logo1.png')" alt="">
                <img class="img_close" @click="showNav = false" :src="require('@/common/images/gujingimgs/close_nav.png')" alt="">
            </div>
        </div>
    </transition> -->
    <!-- <transition name = "slide-sort">
        <div v-show="showNav" class="nav_open_box">
            <img class="img_logo" :src="require('@/common/images/gujingimgs/logo1.png')" alt="">
            <img class="img_menu" @click="showNav = false" :src="require('@/common/images/gujingimgs/close_nav.png')" alt="">
        </div>
    </transition> -->
</div>
</template>

<script>
import {Toast} from 'vant'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'Header2',
    data() {
        return {
            showNav: false,
            showSubNav: false
        }
    },
    mounted() {
        if (this.$route.name === 'MEnterpriseEstimation' || this.$route.name === 'MExcitation') {
            this.showSubNav = true
        }
    },
    methods: {
        aaaaaaaa() {
            Toast('个人中心')
        },
        toPage(name) {
            this.$router.push({name})
        },
        // 退出登录
        loginBtn() {
            // Toast('登录/注册')
            this.$router.push({name: 'MLogin'})
        },
        logout() {
            this.$dialog.confirm({
                title: '',
                message: '确认退出登录？',
                confirmButtonColor: '#409EFF'
            }).then(() => {
                this._logout()
            }).catch(() => {})
        },
        _logout() {
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false,
                zjmemtype: 0
            }
            this.setUser(user)
            sessionStorage.setItem('user', JSON.stringify(user))
        },
        ...mapActions([
            'setLoading',
            'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.header_warp {
    z-index: 100;
    font-family:PingFangSC-Regular,PingFang SC;
    // position: fixed;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    color: #333;
    .nav_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.2rem 0.32rem;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow:0 0.03rem 0.1rem 0 rgba(0,0,0,0.15);
        .img_logo {
            width: 1.84rem;
            height: 0.6rem;
        }
        .img_menu {
            width: 0.4rem;
            height: 0.4rem;
        }
    }
    .nav_open_box {
        box-shadow:0 0.03rem 0.12rem 0 rgba(0,0,0,0.15);
        z-index: 100;
        // background-color: #fff;
        background:rgba(0,0,0,0.4);
        // min-height: 100vh;
        // height: 100vh;
        height: 100%;
        // overflow-y: scroll;
        .main_warp {
            background-color: #fff;
        }
        .nav_box {
            .img_close {
                width: 0.32rem;
                height: 0.32rem;
            }
        }
        .nav_content_box {
            // min-height: calc(100vh - 1.58rem);
            .menu_item_warp {
                margin-top: 0.58rem;
                .menu_item_box {
                    padding: 0 0.32rem;
                    height: 1rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size:0.32rem;
                }
                .menu_item_box:active, .parent_box:active {
                    background-color: rgba(0,0,0,0.04);
                }
                .active_menu {
                    color: #409EFF;
                }
                .gqgj_box {
                    // background-color: pink;
                    .parent_box {
                        padding: 0 0.32rem;
                        height: 1rem;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size:0.32rem;
                        &>i {
                            display: inline-block;
                            width: 0.26rem;
                            height: 0.14rem;
                            background-image: url('../../../common/images/gujingimgs/icon_hid.png');
                            background-size:.26rem 0.14rem;
                        }
                    }
                    .sub_nav_box {
                        display: none;
                        background-color: #F5F7FA;
                        .sub_item:active {
                            background-color: rgba(255,255,255, 0.6);
                        }
                        .sub_item {
                            height: 1rem;
                            display: flex;
                            align-items: center;
                            padding: 0 0.32rem;
                            color: #666;
                            &>p{
                                font-size:0.32rem;
                                padding-left: 0.32rem;
                            }
                            .p_acitve{
                                color: #409EFF;
                                border-left: 0.03rem solid #409EFF;
                                padding-left: 0.29rem;
                            }
                        }
                    }
                }
                .active {
                    .parent_box {
                        color: #409EFF;
                        &>i {
                            background-image: url('../../../common/images/gujingimgs/icon_show.png');
                        }
                    }
                    .sub_nav_box {
                        display: block;
                    }
                }
            }
            .btn_div {
                padding: 0.48rem 0.32rem;
                // background-color: pink;
                .logged_box {
                    display: flex;
                    justify-content: space-between;
                    &>div {
                        font-size: 0.32rem;
                        width: 3.28rem;
                        height: 0.8rem;
                        line-height: 0.8rem;
                        border-radius:0.4rem;
                        text-align: center;
                    }
                    &>div:nth-of-type(1){
                        background-color: #409EFF;
                        color: #FFF;
                    }
                    &>div:nth-of-type(2){
                        // background-color: #fff;
                        box-sizing: border-box;
                        border:0.01rem solid rgba(153,153,153,1);
                        color: #666;
                    }
                }
                .not_login {
                    font-size: 0.32rem;
                    height: 0.8rem;
                    line-height: 0.8rem;
                    text-align: center;
                    border-radius:0.4rem;
                    color: #FFF;
                    background-color: #409EFF;
                }
            }
        }
    }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
    transition: opacity 0.3s;
    opacity: 0
}
// .slide-sort-enter-active, .slide-sort-leave-active{
//     transition: all 0.5s
// }
// .slide-sort-enter, .slide-sort-leave-to{
//     transform: translate3d(100%, 300%, 0)
// }
</style>